// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "co.swopme",
    name: "SWOP",
    homepage: "https://swopme.co/",
    image_id: "6e773b07-efcc-40eb-b3a2-300efc5df800",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/swop-connecting-the-world/id1593201322",
        android: "https://play.google.com/store/apps/details?id=com.travisheron.swopapp&pli=1",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "swopapp://",
        universal: "https://swopme.app",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map